require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/object/get-own-property-descriptor.js
// module id = ../node_modules/core-js/library/fn/object/get-own-property-descriptor.js
// module chunks = 0